/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import Layout from '@bottlebooks/gatsby-theme-event/src/components/Layout/Layout';
import { jsx } from 'theme-ui';
import { Section } from '../components';
import { t, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import {
  Button,
  P,
  Container,
  Text,
  Title,
} from '@bottlebooks/gatsby-theme-base';

export default function ThankYouPage() {
  const { i18n } = useLingui();
  return (
    <Layout page={{ title: i18n._(t`Thank you!`) }}>
      <Section>
        <Title sx={{ marginY: 3 }}>
          <Trans>Thank you!</Trans>
        </Title>
        <P>
          <Trans>Your message has been sent.</Trans>
        </P>
        <Button variant="primary" to="/">
          <Trans>Go to front page</Trans>
        </Button>
      </Section>
    </Layout>
  );
}
